import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
    Button, Typography, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, makeStyles,
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { getTranslate } from 'react-localize-redux';


const useStyles = makeStyles(theme => ({
    title: {

    },
    dialogContent: {
        '&$danger': {
            borderTop: theme.youwell.borders.normal,
            borderColor: theme.palette.error.main,
            paddingTop: theme.spacing(2),
        },
    },
    description: {

    },
    okButton: {

    },
    cancelButton: {

    },
    danger: {
        color: theme.palette.error.main,
    },
}));

const ConfirmDialog = ({
    onClose, dialogTitle, children, open, danger, color,
}) => {
    const translate = useSelector(state => getTranslate(state.localize));
    const classes = useStyles();

    return (
        <Dialog
            disableEscapeKeyDown
            maxWidth="xs"
            open={open}
        >
            {dialogTitle && (
                <DialogTitle className={classes.title}>
                    {dialogTitle}
                </DialogTitle>
            )}
            <DialogContent className={classnames(classes.dialogContent, { [classes.danger]: danger })}>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => onClose(false)} color="default">
                    {translate('cancel')}
                </Button>
                <Button variant={danger ? 'outlined' : 'contained'} onClick={() => onClose(true)} color={danger ? 'inherit' : color} className={classnames({ [classes.danger]: danger })}>
                    {translate('ok')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    dialogTitle: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
    color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
    danger: PropTypes.bool,
};

ConfirmDialog.defaultProps = {
    dialogTitle: null,
    children: null,
    danger: false,
    color: 'primary',
};

const ConfirmButton = ({
    buttonClassName, variant, confirmText, confirmTitle, children, disabled, color, ButtonProps, danger, onClick,
}) => {
    const classes = useStyles();
    const [dialogOpen, setDialogOpen] = React.useState(false);

    const openDialog = () => {
        setDialogOpen(true);
    };

    const closeDialog = (confirmed) => {
        setDialogOpen(false);

        if (confirmed) {
            onClick();
        }
    };

    return (
        <>
            {variant === 'button' && (
                <Button variant={danger ? 'outlined' : 'contained'} onClick={openDialog} color={danger ? 'inherit' : color} className={classnames(buttonClassName, { [classes.danger]: danger })} disabled={disabled} {...ButtonProps}>
                    {children}
                </Button>
            )}
            {variant === 'iconbutton' && (
                <IconButton onClick={openDialog} color={danger ? 'inherit' : color} className={classnames(buttonClassName, { [classes.danger]: danger })} disabled={disabled} {...ButtonProps}>
                    {children}
                </IconButton>
            )}

            <ConfirmDialog open={dialogOpen} onClose={closeDialog} dialogTitle={confirmTitle} danger={danger}>
                <Typography className={classes.description}>
                    {confirmText}
                </Typography>
            </ConfirmDialog>
        </>
    );
};


ConfirmButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    confirmText: PropTypes.string.isRequired,
    confirmTitle: PropTypes.string.isRequired,
    buttonClassName: PropTypes.string,
    disabled: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
    variant: PropTypes.oneOf(['button', 'iconbutton']),
    color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
    ButtonProps: PropTypes.object,
    danger: PropTypes.bool,
};

ConfirmButton.defaultProps = {
    variant: 'button',
    buttonClassName: null,
    disabled: false,
    color: 'default',
    ButtonProps: null,
    danger: false,
};

export default ConfirmButton;
